import React from 'react';
import siteConf from 'pro/config/site';
import { RouteEnum } from 'pro/config/routers';
import Image from '@base/lib/ThemeImage';

type IProps = {
    className?: string;
    logoType?: 'black' | 'white',
    canJump?: boolean;
    width?: number;
    height?: number;
}

const logoSrc = {
    black: 'asset/width-600/picture/2022-03-02/X5Udk3Z4mf7dy12dU1Fer3qdT68egfV2qbCfYa05i5Qc=b=f/d155fa4ec578be93fcdb1e7b.png',
    white: 'file-asset/file/6b931043eca6dae807d325dd58d2d76a.svg'
}

const HeaderLogo: React.FC<IProps> = (props) => {
    const {
        logoType = 'black',
        canJump = true,
        className,
        width = 123,
        height = 23,
    } = props

    return (
        <Image
            className={className}
            href={canJump ? RouteEnum.SHOP : void 0}
            src={logoSrc[logoType]}
            alt={siteConf.brand}
            width={width}
            height={height}
            background={false}
            fixed
        />
    );
};

export default HeaderLogo;